import React from "react"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout.js"
import SectionHeader from "../components/section-header-text.js"
import style from "./index.module.css"


export default function Home({data}) {
  return(
    <Layout>
      <div className={style.parentContainer}>
        <div className = {style.galleryImage}>
        {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 7].homeAssets ? 
        <img src = {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 7].homeAssets} alt = "Gallery Space"/> : 
        <img src = "https://lh3.googleusercontent.com/pw/ACtC-3cko_NuDOFUO0n3LvYGmke3OnYIE8Ucfz6k_3xKUdvENF5aVd4lQwUMvue-wadO9UkCRd65r1uhw2RmvXy_5qMd3iffye4Xxz6ibig4ULpLMlM6KQBLIMRKR-i1N8zbBJBNQn_bYcjJkqPMvq72ipHM=w1390-h943-no?authuser=0"
        alt = "Coming Soon"></img>
        }
          
        </div>
        <div>
          <SectionHeader text = "EXHIBITIONS"/>
          <div className = {style.exhibitionsContainer}>
            <div className = {style.nowExhibContainer}>
              <div className = {style.nowExhib}>
                {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 6].homeAssets ? 
                <img src = {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 6].homeAssets} alt = "Current Exhibition"></img> : 
                <img src = "https://lh3.googleusercontent.com/pw/ACtC-3cko_NuDOFUO0n3LvYGmke3OnYIE8Ucfz6k_3xKUdvENF5aVd4lQwUMvue-wadO9UkCRd65r1uhw2RmvXy_5qMd3iffye4Xxz6ibig4ULpLMlM6KQBLIMRKR-i1N8zbBJBNQn_bYcjJkqPMvq72ipHM=w1390-h943-no?authuser=0"
                alt = "Coming Soon"></img>}
              </div>
              <div className = {style.nowExhibTextContainer}>
              {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 5].homeAssets ? 
              <p className={style.nowExhibTextBold}>{data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 5].homeAssets}</p> : 
              <p className={style.nowExhibTextBold}>Coming Soon</p>}
              {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 4].homeAssets ? 
              <p className={style.nowExhibText}>
              <br/>
                {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 4].homeAssets}
              </p> : 
              <p className={style.nowExhibText}>
              <br/>
              Coming Soon
              </p>
              }
              </div>
            </div>
            <div className = {style.futureExhibContainer}>
              <div className = {style.futureExhibTextContainer}>
              {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 2].homeAssets ? 
                <p className={style.futureExhibTextBold}>{data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 2].homeAssets}</p> :
                <p className={style.futureExhibTextBold}>Coming Soon</p>
              }
              {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 1].homeAssets ? 
                <p className={style.futureExhibText}>
                <br/>
                  {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 1].homeAssets}
                </p> : 
                <p className={style.futureExhibText}>
                <br/>
                Coming Soon
                </p>
              }
              </div>
              <div className = {style.futureExhib}>
              {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 3].homeAssets ? 
                <img src = {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 3].homeAssets} alt = "Future Exhibition"></img> :
                <img src = "https://lh3.googleusercontent.com/pw/ACtC-3cko_NuDOFUO0n3LvYGmke3OnYIE8Ucfz6k_3xKUdvENF5aVd4lQwUMvue-wadO9UkCRd65r1uhw2RmvXy_5qMd3iffye4Xxz6ibig4ULpLMlM6KQBLIMRKR-i1N8zbBJBNQn_bYcjJkqPMvq72ipHM=w1390-h943-no?authuser=0"
                alt = "Coming Soon"></img>
              }
              </div>
            </div>
            <div className = {style.exhibitionSeeAll}>
              <Link to="/exhibitions" className = {style.seeAll}>SEE ALL &gt;&gt;</Link>
            </div>
          </div>
        </div>
        <div>
          <SectionHeader text = "YOUTUBE"/>
          <div className = {style.youtubeTextContainer}>
            <div>
            {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 3].youtube ? 
              <iframe
              src= {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 3].youtube}>
              </iframe> :
              <iframe
              src="https://www.youtube.com/embed/gT3l0UuNbR8">
              </iframe>
            }
            </div>
            {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 2].youtube ? 
              <p className = {style.youtubeTextBold}>
              {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 2].youtube}</p> : 
              <p className = {style.youtubeTextBold}>
              広島のアートを斬る！だけでなく癒す！かまいたちのよる <br/>
              平石もも　今井みはる　（司会）黒田大スケ</p>
            }
            {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 1].youtube ? 
              <p className = {style.youtubeText}><br/><br/>
              {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 1].youtube} UP
              </p> : 
              <p className = {style.youtubeText}><br/><br/>
              2021年1月8日（金）UP
              </p>
            }
            <a href="https://www.youtube.com/channel/UCX2J5F_wd70ZllCxS163OJg" className = {style.youtubeSeeAll + ' ' + style.seeAll}>
            SEE ALL &gt;&gt;
            </a>
          </div>
        </div>
        <div>
          <SectionHeader text = "NEWS"/>
          <div className = {style.newsContainer}>
          {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 1].homeUpdates ?
            <p className = {style.newsText}>
            {data.googleSheet.Sheet1[data.googleSheet.Sheet1.length - 1].homeUpdates}
            </p> : 
            <p className = {style.newsText}>
              <br/>
            </p>
          }
          </div>
        </div>
      </div>
    </Layout>
  )
}


export const query = graphql`
query {
  googleSheet {
    Sheet1 {
      homeAssets
      homeUpdates
      youtube
    }
  }
}`

//            <Link to="/"className = {style.seeAll}>
//SEE ALL &gt;&gt;
//</Link>
